/**
 * Created by chengy on 2019/7/3.
 */

export const storageApiMap = {
  //附件上传
  uploadAtt:'storage/v1/upload',
  //删除附件
  deleteAtt:'storage/v1/delete'
}
